export default __webpack_public_path__ + "static/media/indicator-completed.4fc9f1ac.svg";